import { render, staticRenderFns } from "./GroupedOptionsDropdown.vue?vue&type=template&id=2b40e245&scoped=true"
import script from "./GroupedOptionsDropdown.vue?vue&type=script&lang=js"
export * from "./GroupedOptionsDropdown.vue?vue&type=script&lang=js"
import style0 from "./GroupedOptionsDropdown.vue?vue&type=style&index=0&id=2b40e245&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40e245",
  null
  
)

export default component.exports